import React from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import {Tooltip} from 'react-tooltip'

const ModalAI = (props) => {
  const {modalRef, loadingModalContent, modalContent} = props

  return (
    <div
      className='modal fade'
      id='modalAI'
      aria-hidden='true'
      aria-labelledby='exampleModalToggleAI'
      tabIndex={-1}
      ref={modalRef}
    >
      <div className='modal-dialog modal-dialog-scrollable modal-lg'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title' id='exampleModalToggleAI'>
              Assistance AI
            </h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body d-flex'>
            {loadingModalContent ? (
              <div className='text-center'>
                <span className='spinner-border spinner-border-sm align-middle ms-2 w-30px h-30px'></span>
                <span className='ms-2'>Chargement...</span>
              </div>
            ) : (
              <pre style={{whiteSpace: 'pre-wrap', wordWrap: 'break-word'}}>{modalContent}</pre>
            )}
          </div>
          <div className='modal-footer'>
            <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
              Fermer
            </button>
          </div>
        </div>
      </div>
      <Tooltip id='modal-tooltip' />
    </div>
  )
}

export default ModalAI
